"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportHistory = void 0;
var SportHistory_1 = require("./SportHistory");
Object.defineProperty(exports, "SportHistory", { enumerable: true, get: function () { return __importDefault(SportHistory_1).default; } });
